<template>
  <v-card v-if="vehicle">
    <v-btn color="grey" small class="tariff-left-headers">
      <h3>{{ $i18n.t("Vehicle Profile") }}</h3>
    </v-btn>
    <v-btn
      color="white"
      style="float: right"
      small
      class="tariff-right-headers"
      v-if="vehicle.addedDay"
      >Added at: {{ vehicle.addedDay }}</v-btn
    >
    <v-btn
      color="white"
      style="float: right"
      small
      class="tariff-right-headers"
      v-if="vehicle.addedBy"
      >Added by: {{ vehicle.addedBy }}</v-btn
    >
    <v-row style="padding: 10px 10px">
      <v-col cols="12" sm="12" md="6" lg="6">
        <z-vendor-select
          withSelf
          :label="$i18n.t('Owner') + '*'"
          v-if="vehicle.showAssignedTo || !isEdit"
          v-model="vehicle.corp_id"
          :disabled="!vehicle.vehicleDetail.iamOwner && isEdit"
          autocomplete="off"
        ></z-vendor-select>
        <label v-if="!vehicle.showAssignedTo && isEdit"
          >Owner : {{ vehicle.vendorName }}</label
        >
      </v-col>
      <v-col cols="12" sm="12" md="6" lg="6">
        <z-client-select
          withSelf
          :label="$i18n.t('Assigned To')"
          v-if="vehicle.showAssignedTo || !isEdit"
          v-model="vehicle.assignedTo"
        ></z-client-select>
        <label v-if="!vehicle.showAssignedTo && isEdit"
          >Owner : {{ vehicle.assignedToName }}</label
        >
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-text-field
          :label="$i18n.t('Vehicle Reg. No') + '*'"
          v-model="vehicle.regNo"
          :rules="validationrules.regNo"
          maxlength="35"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <z-name-master-select
          :hideAddNew="true"
          v-model="vehicle.bodyType"
          :rules="validationrules.bodyType"
          :label="'Body Type *'"
          :type="10"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <z-vehicle-type-select
          categories="true"
          v-model="vehicle.truckType"
          :bodyType="vehicle.bodyType"
          :rules="validationrules.truckType"
          :label="'Truck Type *'"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <z-vehicle-type-select
          v-model="vehicle.vehicleType"
          :label="'Vehicle Type'"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-text-field
          :label="$i18n.t('Body Length')"
          v-model="vehicle.length"
          type="number"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="7"
        >
          <span slot="append" color="purple"> Feet </span>
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-text-field
          :label="$i18n.t('Capacity')"
          v-model="vehicle.capacity"
          type="number"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="7"
        >
          <span slot="append" color="purple"> Tonnes </span>
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-select
          :label="$i18n.t('Axel')"
          :items="[
            { name: 'Single Axel', value: 1 },
            { name: 'Multi Axel', value: 2 },
          ]"
          v-model="vehicle.axel"
          item-text="name"
          item-value="value"
          type="number"
        ></v-select>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-text-field
          :label="$i18n.t('Wheels')"
          v-model="vehicle.wheels"
          type="number"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="3"
        >
          <v-icon slot="append" color="purple"> mdi-wheel </v-icon>
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <z-country-select
          madatoryMark="true"
          v-model="vehicle.country"
          :rules="validationrules.country"
        />
      </v-col>
      <!-- <v-col cols="12" sm="6" md="4" lg="3">
        <v-autocomplete
          :label="$i18n.t('Color')"
          :items="CommonUtil.getColorsList()"
          v-model="vehicle.color"
          item-text="name"
          item-value="value"
        ></v-autocomplete>
      </v-col> -->
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-autocomplete
          :label="$i18n.t('Year')"
          :items="years"
          v-model="vehicle.year"
          item-text="name"
          item-value="value"
          type="number"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <z-zone-select v-model="vehicle.zone_id" />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-text-field
          :label="$i18n.t('KMs Done')"
          v-model="vehicle.kms"
          type="number"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="7"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-autocomplete
          :label="$i18n.t('Fuel Type')"
          :items="CommonUtil.getFuelTypeList()"
          v-model="vehicle.fuelType"
          item-text="name"
          item-value="value"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-autocomplete
          :label="$i18n.t('Alternate Fuel Type')"
          :items="CommonUtil.getFuelTypeList()"
          v-model="vehicle.altFuelType"
          item-text="name"
          item-value="value"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-autocomplete
          :label="$i18n.t('Driver Side')"
          :items="[
            { name: 'Right Side', value: 1 },
            { name: 'Left Side', value: 2 },
          ]"
          v-model="vehicle.driveSide"
          item-text="name"
          item-value="value"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-autocomplete
          :label="$i18n.t('Transmission')"
          :items="[
            { name: 'Manual', value: 1 },
            { name: 'Automatic', value: 2 },
            { name: 'Auto pilot', value: 3 },
          ]"
          v-model="vehicle.transmission"
          item-text="name"
          item-value="value"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-autocomplete
          :label="$i18n.t('Status')"
          :items="[
            { name: 'Active', value: 1 },
            { name: 'Inactive', value: 2 },
            { name: 'Under Maintenance', value: 3 },
            { name: 'Sold', value: 4 },
          ]"
          v-model="vehicle.status"
          item-text="name"
          item-value="value"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-checkbox
          v-model="vehicle.marketVeh"
          :label="$i18n.t('Market Vehicle')"
        ></v-checkbox>
      </v-col>
    </v-row>
    <v-row style="padding: 10px 10px" v-if="vehicle.marketVeh">
      <v-col cols="12" sm="6" md="6" lg="7">
        <v-text-field
          :label="$i18n.t('Owner Name')"
          class="purple-input"
          v-model="vehicle.ownerInfo.name"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="5">
        <v-text-field
          :label="$i18n.t('PAN No.')"
          class="purple-input"
          v-model="vehicle.ownerInfo.pan"
        />
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-row>
          <v-col cols="12" sm="2" md="2" lg="2">
            <v-select
              :label="$i18n.t('Salutation')"
              :items="[
                { name: 'Mr.', value: 'Mr.' },
                { name: 'Ms.', value: 'Ms.' },
                { name: 'Mrs.', value: 'Mrs.' },
              ]"
              v-model="vehicle.ownerInfo.contactPerson.salutation"
              item-text="name"
              item-value="value"
              type="number"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="5" lg="5">
            <v-text-field
              :label="$i18n.t('Contact Person Name')"
              class="purple-input"
              v-model="vehicle.ownerInfo.contactPerson.name"
            />
          </v-col>
          <v-col cols="12" sm="6" md="5" lg="5">
            <v-text-field
              :label="$i18n.t('Email')"
              class="purple-input"
              v-model="vehicle.ownerInfo.contactPerson.email"
            />
          </v-col>
          <v-col cols="12" sm="2" md="2" lg="2">
            <z-country-select
              isd
              hideName
              hideFlag
              v-model="vehicle.ownerInfo.contactPerson.countryCode"
              :label="$i18n.t('Country Code')"
            />
          </v-col>
          <v-col cols="12" sm="3" md="3" lg="3">
            <v-text-field
              :label="$i18n.t('Phone')"
              class="purple-input"
              type="number"
              v-model="vehicle.ownerInfo.contactPerson.phone"
            />
          </v-col>
          <v-col cols="12" sm="6" md="6" lg="4">
            <v-text-field
              :label="$i18n.t('Other Phones')"
              class="purple-input"
              v-model="vehicle.ownerInfo.contactPerson.otherPhone"
            />
          </v-col>
          <v-col cols="12" sm="6" md="6" lg="3">
            <v-text-field
              :label="$i18n.t('Other Emails')"
              class="purple-input"
              v-model="vehicle.ownerInfo.contactPerson.otherEmail"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row style="padding: 10px 10px" v-if="vehicle.marketVeh">
      <v-col cols="12" sm="6" md="4" lg="4">
        <z-country-select
          class="purple-input"
          v-model="vehicle.ownerInfo.address.country"
        ></z-country-select>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="4">
        <z-state-select
          class="purple-input"
          v-model="vehicle.ownerInfo.address.state"
          :country="vehicle.ownerInfo.address.country"
        ></z-state-select>
      </v-col>

      <v-col cols="12" sm="6" md="4" lg="4">
        <z-city-select
          class="purple-input"
          v-model="vehicle.ownerInfo.address.city"
          :state="vehicle.ownerInfo.address.state"
          :country="vehicle.ownerInfo.address.country"
        ></z-city-select>
      </v-col>
      <v-col cols="12" sm="6" md="8" lg="8">
        <v-text-field
          :label="$i18n.t('Address')"
          dense
          v-model="vehicle.ownerInfo.address.addressLine"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="4">
        <v-text-field
          :label="$i18n.t('Pincode')"
          dense
          v-model="vehicle.ownerInfo.address.pinCode"
        ></v-text-field>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
// import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import { CommonUtil } from "@/js/commonUtil";

@Component({
  name: "Profile",
  props: {
    value: {
      default: null,
    },
    isEdit: {
      default: null,
    },
  },
})
export default class Profile extends Vue {
  vehicle = null;
  CommonUtil = CommonUtil;

  get loading() {
    return common.loading;
  }

  @Watch("value")
  onValueChange(newVal) {
    this.vehicle = newVal;
  }

  years = [];

  async mounted() {
    if (this.value) this.vehicle = this.value;

    if (!this.vehicle) this.vehicle = {};
    if (!this.vehicle._id) this.vehicle.axel = 1;
    if (!this.vehicle.vehicleDetail) this.vehicle.vehicleDetail = {};
    if (!this.vehicle.vehicleDetail.fitness)
      this.vehicle.vehicleDetail.fitness = {};

    // for (let i = 2000; i < [...Array(2020).keys()].length; i++) {
    //   this.years.push({ name: i, value: i });
    // }
    const currentYear = new Date().getFullYear();
    for (let i = 2000; i <= currentYear; i++) {
      this.years.push({ name: i, value: i });
    }
  }

  validationrules = {
    regNo: [(v) => !!v || this.$i18n.t("Registration No. is required")],
    bodyType: [(v) => !!v || this.$i18n.t("Body Type is required")],
    truckType: [(v) => !!v || this.$i18n.t("Truck Type is required")],
    country: [(v) => !!v || this.$i18n.t("Country is required")],
    fuelType: [(v) => !!v || this.$i18n.t("Fuel Type is required")],
  };

  years = [];

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }
}
</script>

<style scoped>
.tariff-left-headers {
  text-transform: none;
  color: #555;
  top: -10px;
  left: 10px;
  right: 0px;
  font-size: 12px;
}
.tariff-right-headers {
  text-transform: none;
  color: #555;
  top: -10px;
  right: 10px;
  font-size: 12px;
}
.close-button {
  text-transform: none;
  color: rgb(255, 66, 66);
  bottom: 7px;
  /* top: -10px; */
  right: 0px;
  font-size: 12px;
  position: absolute;
  z-index: 100;
}
.tab-pane {
  display: none;
}
</style>